import { serializeToJson } from "@/functional/datetimehelper";
import { AsyncRestClient } from "@/infrastructure/backend/async/AsyncRestClient";
import { Identity } from "@/infrastructure/backend/userIdentity";
import { Dictionary } from "@/infrastructure/generics/dictionary";
import { NamedListItem } from "@/infrastructure/generics/namedListItem";

export class ComboBoxDataSource {
    private static sources: Dictionary<Array<NamedListItem> | undefined> = {}

    public static async initNamedLists() {
       //await ComboBoxDataSource.GetList("AlarmPlan", "")
       await ComboBoxDataSource.GetList("KommKanal", "")
       await ComboBoxDataSource.GetList("GeraeteTyp", "")
       //await ComboBoxDataSource.GetList("GeoObjekt", "")
       await ComboBoxDataSource.GetList("SprachCode", "Sprache")
       await ComboBoxDataSource.GetList("Einsatzzweck", "Sprache")
       await ComboBoxDataSource.GetList("Notfallumgebung", "Sprache")
       await ComboBoxDataSource.GetList("Anrede", "Sprache")
       await ComboBoxDataSource.GetList("Land", "Sprache")
       await ComboBoxDataSource.GetList("Erreichbarkeit", "Sprache")
       await ComboBoxDataSource.GetList("NutzerProfil", "")
       await ComboBoxDataSource.GetList("Rolle", "")
       await ComboBoxDataSource.GetList("ZweckBereich", "Sprache")
       await ComboBoxDataSource.GetList("AlarmHinweisKategorie", "Sprache")
       //await ComboBoxDataSource.GetList("PersonBereich", "")
       await ComboBoxDataSource.GetList("EskalationBeziehung", "Sprache")
       await ComboBoxDataSource.GetList("EskalationKategorie", "Sprache")

       await ComboBoxDataSource.GetList("GeoObjektTyp", "Sprache")
       await ComboBoxDataSource.GetList("Zutritt", "Sprache")
       await ComboBoxDataSource.GetList("PoiKategorie", "Sprache")

       await ComboBoxDataSource.GetList("OrtsmarkenTyp", "")
       
       
       //await ComboBoxDataSource.GetList("EskalationsPartnerPublic", "")
       //await ComboBoxDataSource.GetList("EinsatzZentrale", "")
       //await ComboBoxDataSource.GetList("Einsatzgebiet", "")
       

       

    //    await ComboBoxDataSource.GetList("Geraet", "")
    //    await ComboBoxDataSource.GetList("Weiterleitung", "")

    }

    public static async GetList( sourceName: string, filter: string, lifeFilter: string = "") {
        await this.AddList( sourceName, filter, lifeFilter)
        return this.sources[sourceName];
    }

    private static async AddList( sourceName: string, filter: string, lifeFilter: string) {
        if ( this.sources[sourceName] === undefined 
            || sourceName === "MandantBereich" 
            || sourceName === "PersonBereich" 
            || sourceName === "WeiterleitungBereich"
            || (lifeFilter && lifeFilter.length > 0)
        
        ) {            
            const result = await this.getData(sourceName, filter, lifeFilter)            
            this.sources[sourceName] = result
        }
    }

    public static AddOrUpdateList( sourceName: string, keyValueList: NamedListItem[]) {
        this.sources[sourceName] = keyValueList
    }

    private static async ClearList( sourceName: string) {
        if ( this.sources[sourceName] !== undefined ) {            
            this.sources[sourceName] = undefined
        }
    }

    private static async getData(sourceName: string, filter: string, lifeFilter: string) : Promise<any> {
        const dataSourceClient = AsyncRestClient.Create(true);
        if (dataSourceClient.isFailure) return;

        const result = await dataSourceClient
            .getValue()
            .exchangeForComponents<string, any>(process.env.VUE_APP_API + "api/comboBox/getListByType", serializeToJson({DataSourceName: sourceName, Filter: filter, LifeFilter: lifeFilter, UserId: Identity.getIdentity().getValue().UserId}));       
        if (result.isFailure) return;
        return result.getValue()
    }
}